import { render } from "./SelectGroupTraineesModal.vue?vue&type=template&id=7cfa22b4&scoped=true"
import script from "./SelectGroupTraineesModal.vue?vue&type=script&lang=js"
export * from "./SelectGroupTraineesModal.vue?vue&type=script&lang=js"

import "./SelectGroupTraineesModal.vue?vue&type=style&index=0&id=7cfa22b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfa22b4"]])

export default __exports__